import React, { Component } from 'react'
import '../style/SearchForm.css';


export default class SearchForm extends Component {
    render() {
        return (
            <div>
                <form id="searchform_form" onSubmit={(e) => { e.preventDefault(); this.props.submit() }}>
                    <div>
                        <label htmlFor="id">
                            Identifiant :
                        </label>
                        <input id="id" name="id" type="text" value={this.props.id} onChange={(e) => this.props.change(e)} className="form_margin"/>
                    </div>
                    <div>
                        <label htmlFor="type">
                            Type :
                        </label>
                        <select id="type" name='type' value={this.props.type} onChange={(e) => this.props.change(e)}  className="form_margin">
                            <option value=""/>
                            <option value="Ajouté">Ajouté</option>
                            <option value="Supprimé">Supprimé</option>
                            <option value="Modifié">Modifié</option>
                        </select>
                    </div>
                    <div>
                        <label htmlFor="since">
                            Depuis :
                        </label>
                        <input id="since" name="since" type="date" value={this.props.since} onChange={(e) => this.props.change(e)}  className="form_margin"/>
                    </div>
                    <div>
                        <label htmlFor="to">
                            Jusqu'à :
                        </label>
                        <input id="to" name="to" type="date" value={this.props.to} onChange={(e) => this.props.change(e)} className="form_margin"/>
                    </div>
                    <button type="submit" className="form_margin" id="blue_button">Filtrer</button>
                </form>
            </div>
        )

    }

}